import './Select.scss';
import {useEffect, useRef, useState} from "react";

type SelectProps = {
    data: Array<string>;
    label: string;
    onChange: (activeItems: Array<string>) => void;
    allLabel?: string;
    current?: Array<string>;
}
const Select = ({data, label, onChange, allLabel = 'Wszystkie', current}: SelectProps) => {

    const ref = useRef<HTMLDivElement>(null);
    const [active, setActive] = useState([allLabel]);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const checkIfClickedOutside = (e: { target: any; }) => {
            if (open && ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [open])

    useEffect(() => {
        if (current && !current.length) {
            setActive([allLabel]);
        } else if (current) {
            setActive(current);
        }
    }, [current, allLabel]);

    const trigger = () => {

        const isActiveFilters = active[0] !== allLabel;

        const onOptionClick = (e: any, item: string) => {
            const restItems = [...active.filter(a => a !== item)];
            e.stopPropagation();
            onChange(active.length === 1 ? [] : restItems);
            setActive(active.length === 1 ? [allLabel] : restItems);
        }

        return <div
            className={'custom-select-trigger ' + (isActiveFilters ? 'custom-select-trigger--active' : '')}
            onClick={() => setOpen(!open)}>
            {isActiveFilters ?
                <>
                    {active.map((item, i) => (
                        <div className="option" key={i} onClick={(e) => onOptionClick(e, item)}>
                            <span>{item}</span>
                            <div className="custom-select-clear"/>
                        </div>
                    ))}
                </> : <span>{allLabel}</span>
            }
        </div>;
    }

    const clearAll = () => {
        return active[0] !== allLabel && <div className="custom-select-clear" onClick={() => {
            onChange([]);
            setActive([allLabel]);
            setOpen(false);
        }}/>;
    };

    const optionsView = () => {
        const onClick = (value: string) => {
            const isActiveFilters = active[0] === allLabel;
            if (!active.includes(value)) onChange(isActiveFilters ? [value] : [...active, value]);
            setActive(previousValue => {
                if (!previousValue.includes(value)) return isActiveFilters ? [value] : [...previousValue, value];
                return previousValue;
            });
            setOpen(false);
        }

        return <div className="custom-options">
            {data.sort().map((value, i) => (
                    <span className={"custom-option" + (active.includes(value) ? ' custom-option--active' : '')}
                          onClick={() => onClick(value)}
                          key={i}>{value}</span>
                )
            )}
        </div>
    }

    return (<>
            <div className={'custom-select-container'}>
                <span className={'custom-select-label'}>{label}</span>
                <div className={open ? 'custom-select custom-select--open' : 'custom-select'} ref={ref}>
                    {trigger()}
                    {clearAll()}
                    {optionsView()}
                </div>
            </div>
        </>
    )
};

export {Select}